import axios from 'axios';

const ENDPOINT = 'processpermission';

const AXIOS_JSON = {headers: {
  'Content-Type': 'application/json',
}};

export default {
  delete: async (site_id, properm_id) => {
    const url = `${site_id}/${ENDPOINT}/${properm_id}/`;
    const response = await axios.delete(url);
    return response.data;
  },
};
